import type { Transaction } from 'firebase/firestore';

export class TransactionManager {
  static transaction: Transaction;

  static exists(): boolean {
    return !!TransactionManager.transaction;
  }

  static get(): Transaction {
    return TransactionManager.transaction;
  }

  static set(t: Transaction): void {
    TransactionManager.transaction = t;
  }

  static unset(): void {
    TransactionManager.transaction = null;
  }
}
